import { render, staticRenderFns } from "./Sustainappbility.vue?vue&type=template&id=107c3ac1&scoped=true&"
import script from "./Sustainappbility.vue?vue&type=script&lang=js&"
export * from "./Sustainappbility.vue?vue&type=script&lang=js&"
import style0 from "./Sustainappbility.vue?vue&type=style&index=0&id=107c3ac1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c3ac1",
  null
  
)

export default component.exports